<template>
  <div class="border-t border-slate-700 pt-2">
    <button type="button" class="flex items-center gap-1.5 text-xs text-cyan-400 hover:text-cyan-300"
      :aria-expanded="open" @click="open = !open">
      <span class="inline-block transition-transform" :class="{ 'rotate-90': open }">▸</span>
      Value Transforms
      <span v-if="pipeline.length" class="text-gray-500 font-normal">({{ pipeline.length }})</span>
    </button>
    <div v-if="open" class="mt-2">
      <TransformEditor :pipeline="pipeline" />
    </div>
  </div>
</template>

<script setup>
/**
 * CollapsibleTransformsSection.vue
 *
 * Single shared wrapper around TransformEditor.vue — chevron + label + step
 * count, progressively disclosed. Extracted from MappingBindingEditor.vue
 * (the only place this existed before) so StateBindingEditor.vue can reuse
 * the exact same interaction rather than duplicating it. Owns its own
 * open/closed state; starts open only when the pipeline already has steps,
 * matching the disclosure rule every other collapsible section in this
 * editor family already follows.
 */
import { ref } from 'vue';
import TransformEditor from './TransformEditor.vue';

const props = defineProps({
  pipeline: { type: Array, required: true }, // TransformStep[] — passed straight through to TransformEditor
});

const open = ref(props.pipeline.length > 0);
</script>
